import React from "react";

export const defaultTermsSection = (
  <>
    <p className="bold">Please read the below carefully.</p>
    <p className="bold">By submitting an application:</p>
    <ul>
      <li>
        I confirm I have the legal authority to submit this personal loan
        application on behalf of myself the client and I declare all details I
        have provided in this application are true and correct.
      </li>
      <li>
        I have read and agreed to the terms set out in the{" "}
        <a
          href="https://wisrau.blob.core.windows.net/public/PrivacyConsent-20181024.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Consent Form
        </a>
        .
      </li>
      <li>
        I confirm that I am authorised to provide the personal details presented
        and I consent to my information being checked with the document issuer
        or official record holder via third party systems and services for the
        purpose of confirming my identity. I acknowledge that all applications
        are subject to Wisr Finance Pty Ltd lending criteria.
      </li>
      <li>
        I consent to the receipt of notices and other documents electronically
        as per the{" "}
        <a id="communicationConsentLink">
          Electronic Communication Consent Details
        </a>
        .
      </li>
      <li>
        I consent to Wisr Finance Pty Ltd making a “hard” enquiry against my
        credit file for the purpose of assessing my application for credit and I
        understand that this may impact my credit score. For more information on
        “hard” enquiries, please see{" "}
        <a
          href="https://wisr.com.au/help-centre/what-is-a-hard-enquiry"
          target="_blank"
          rel="noopener noreferrer"
        >
          FAQs
        </a>
        .
      </li>
    </ul>
  </>
);

export const defaultCommunicationConsentSection = (
  <div id="communicationConsent">
    <p>
      To: Wisr Finance Pty Ltd (ABN 39 119 503 221, Australian Credit Licence
      458572),
    </p>
    <p>I understand that by ticking this box I have given consent such that:</p>
    <ol>
      <li>
        Wisr may no longer send paper copies of notices and other documents to
        me;
      </li>
      <li>
        I should regularly check my nominated email address for notices and
        other documents;
      </li>
      <li>
        Wisr may send the notices and other documents by email, or provide a
        notice in an email that the documents are displayed on and can be
        retrieved from a website;
      </li>
      <li>
        I may withdraw my consent to the giving of notices and other documents
        by electronic means at any time; and
      </li>
      <li>
        I have the facilities to enable me to print the notices or other
        documents sent to me electronically.
      </li>
    </ol>
  </div>
);
